import { render, staticRenderFns } from "./OPDetailProvider.vue?vue&type=template&id=93f8d9fc&scoped=true&"
import script from "./OPDetailProvider.vue?vue&type=script&lang=js&"
export * from "./OPDetailProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f8d9fc",
  null
  
)

export default component.exports